// extracted by mini-css-extract-plugin
export var activeChildItem = "DesktopNav-module--activeChildItem--xS9l5";
export var activeItem = "DesktopNav-module--activeItem--r0sMF";
export var collapsed = "DesktopNav-module--collapsed--tSsEu";
export var disabled = "DesktopNav-module--disabled--3kdVY";
export var navChildItem = "DesktopNav-module--navChildItem--DV9fm";
export var navChildren = "DesktopNav-module--navChildren--rysjW";
export var navItem = "DesktopNav-module--navItem--r1lN-";
export var navItemIcon = "DesktopNav-module--navItemIcon--KNtcA";